import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "./pages/Layout";
import MapEditor from "./pages/MapEditor";
import MapSelector from "./pages/MapSelector";
import MapBlocker from "./pages/MapBlocker";
import MapChannel from "./pages/MapChannel";
import MapDetail from "./pages/MapDetail";

const App = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="/" element={<MapEditor />} />
                <Route path="/map-selector" element={<MapSelector />} />
                <Route path="/map-blocker" element={<MapBlocker />} />
                <Route path="/map-channel" element={<MapChannel />} />
                <Route path="/map-detail" element={<MapDetail />} />
            </Route>
        </Routes>
    );
};

export default App;
